let multiLang = {
	'zh-CN': {
		required: '此项为必填',
		phoneErr: '请正确填写手机号码',
		emailErr: '请输入有效的邮箱',
		more: '更多',
		fillName: '请输入您的姓名',
		fillTel: '请输入您的联系电话',
		fillEmail: '请输入您的电子邮箱',
		fillCompany: '请输入您的公司名称',
		fillMsg: '请输入留言内容',
		regexpTel: /^1[3-9]\d{9}$/,
	},
	jp: {
		required: 'この項目は必須です',
		phoneErr: '携帯電話番号を正しく入力してください',
		emailErr: '有効なメールアドレスを入力してください',
		more: 'もっと',
		fillName: 'お名前をご入力ください',
		fillTel: 'お電話番号をご入力ください',
		fillEmail: 'メールアドレスをご入力ください',
		fillCompany: '会社名をご入力ください',
		fillMsg: '詳細をご記入ください',
		regexpTel: /^(?:\+81[\s-]?(?:70|80|90|20)|0(?:70|80|90|20))[\s-]?\d{4}[\s-]?\d{4}$/,
	},
};

export default function Language() {
	const langCode = document.documentElement.getAttribute('lang');

	let lang = multiLang[langCode];

	return lang;
}
